import React from 'react';
import { Button, Badge, Card } from './ui';
import { FileText, Zap, ShieldCheck, Lock, CreditCard, Star, XCircle, CheckCircle, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-4 pb-16 md:pt-6 md:pb-24 px-4 overflow-hidden pl-[16px] pr-[16px]" data-id="element-12">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-13"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-14">
        <div className="inline-flex items-center gap-2 mb-4" data-id="element-15">
          <span className="text-2xl" data-id="element-16">🧊</span>
          <span className="text-brand-400 font-bold tracking-widest uppercase text-sm md:text-base" data-id="element-17">
            PUNTO DIGITAL™
          </span>
        </div>

        <h1 className="md:text-6xl font-black text-white mb-4 tracking-tight text-[26px]" data-id="element-18">
          Todo tu año de comida.
          <br data-id="element-19" />
          <span className="text-brand-400 text-glow" data-id="element-20">Listo. Desde hoy.</span>
        </h1>

        <div className="relative mt-4 mb-6 flex justify-center" data-id="element-21">
          <div className="absolute inset-0 bg-brand-500/20 blur-[80px] rounded-full pointer-events-none" data-id="element-22"></div>
          <img src="https://cdn.magicpatterns.com/uploads/7G1ge6MhrnMniAHTMLEuia/mockup_hecho_.png" alt="Megapack Freezer Lleno — caja con los 12 tomos y bonos del sistema de batch cooking" className="relative z-10 w-full max-w-lg h-auto drop-shadow-2xl pl-[45px] pr-[45px]" width={800} height={800} loading="eager" fetchPriority="high" decoding="async" data-id="element-23" />
        </div>

        <p className="md:text-xl text-slate-300 mb-4 font-medium max-w-3xl mx-auto text-[16px]" data-id="element-24">
          Megapack Freezer Lleno — Combo Completo
        </p>

        <p className="text-slate-400 max-w-2xl mx-auto text-[14px] mt-[3px] mb-[3px]" data-id="element-25">
          El sistema N°1 de batch cooking para familias argentinas. Recetas,
          sistema y planificación listos para usar — sin improvisar, sin
          delivery y sin perder los domingos.
        </p>

        <div className="flex flex-nowrap justify-center gap-2 mb-8 overflow-x-auto" data-id="element-26">
          <Badge className="whitespace-nowrap" data-id="element-27">
            <FileText className="w-4 h-4 mr-2" data-id="element-28" /> 100% PDF
          </Badge>
          <Badge className="whitespace-nowrap" data-id="element-29">
            <Zap className="w-4 h-4 mr-2 text-amber-400" data-id="element-30" /> Acceso en 5 min
          </Badge>
          <Badge className="whitespace-nowrap" data-id="element-31">
            <span className="mr-2" data-id="element-32">🧊</span> 150+ recetas listas
          </Badge>
        </div>

        <div className="flex flex-col items-center gap-6" data-id="element-33">
          <Button size="md" className="w-full md:w-auto group" onClick={() => document.getElementById('planes')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-34">
            <span className="mr-2 text-lg group-hover:scale-110 transition-transform" data-id="element-35">
              🧊
            </span>
            QUIERO MI MEGAPACK FREEZER LLENO AHORA
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-36" />
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-slate-400" data-id="element-37">
            <span className="flex items-center" data-id="element-38">
              <ShieldCheck className="w-4 h-4 mr-1 text-emerald-400" data-id="element-39" /> Garantía
              7 días
            </span>
            <span className="flex items-center" data-id="element-40">
              <Lock className="w-4 h-4 mr-1 text-slate-300" data-id="element-41" /> Pago seguro
            </span>
            <span className="flex items-center" data-id="element-42">
              <CreditCard className="w-4 h-4 mr-1 text-blue-400" data-id="element-43" /> Mercado Pago
            </span>
          </div>
        </div>
      </div>
    </section>;
}
export function Testimonials() {
  return <section className="py-10 bg-slate-900/50 border-y border-slate-800" data-id="element-44">
      <div className="max-w-6xl mx-auto px-4" data-id="element-45">
        <div className="flex flex-wrap justify-center gap-6 md:gap-14 text-center mt-[22px] mb-[22px]" data-id="element-46">
          <div data-id="element-47">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-48">+1.200</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-49">
              familias confían
            </p>
          </div>
          <div data-id="element-50">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-51">6</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-52">
              Tomos listos
            </p>
          </div>
          <div data-id="element-53">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-54">6</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-55">
              Bonos incluidos
            </p>
          </div>
          <div data-id="element-56">
            <p className="text-3xl font-bold text-white mb-1 flex items-center justify-center gap-1" data-id="element-57">
              4.9/5 <Star className="w-6 h-6 fill-amber-400 text-amber-400" data-id="element-58" />
            </p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-59">
              calificación
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-60">
          <Card className="bg-slate-900" data-id="element-61">
            <div className="flex gap-1 mb-4" data-id="element-62">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-63" />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-64">
              "Organicé todo el año en una tarde. El sistema de batch cooking me
              ahorra horas cada semana."
            </p>
            <div className="flex items-center gap-3" data-id="element-65">
              <div className="w-10 h-10 rounded-full bg-brand-900 flex items-center justify-center text-brand-400 font-bold" data-id="element-66">
                MG
              </div>
              <div data-id="element-67">
                <p className="font-bold text-white" data-id="element-68">Mariana G.</p>
                <p className="text-xs text-slate-500" data-id="element-69">Córdoba</p>
              </div>
            </div>
          </Card>

          <Card className="bg-slate-900" data-id="element-70">
            <div className="flex gap-1 mb-4" data-id="element-71">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-72" />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-73">
              "El Tomo de Proteínas por fin me enseñó a comprar en la
              carnicería. Bajo el 40% del gasto y como mejor que antes."
            </p>
            <div className="flex items-center gap-3" data-id="element-74">
              <div className="w-10 h-10 rounded-full bg-emerald-900 flex items-center justify-center text-emerald-400 font-bold" data-id="element-75">
                LP
              </div>
              <div data-id="element-76">
                <p className="font-bold text-white" data-id="element-77">Laura P.</p>
                <p className="text-xs text-slate-500" data-id="element-78">Rosario</p>
              </div>
            </div>
          </Card>

          <Card className="bg-slate-900" data-id="element-79">
            <div className="flex gap-1 mb-4" data-id="element-80">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-81" />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-82">
              "El Tomo de Invierno vale cada peso. Los guisos del domingo
              resuelven toda la semana."
            </p>
            <div className="flex items-center gap-3" data-id="element-83">
              <div className="w-10 h-10 rounded-full bg-blue-900 flex items-center justify-center text-blue-400 font-bold" data-id="element-84">
                RM
              </div>
              <div data-id="element-85">
                <p className="font-bold text-white" data-id="element-86">Roberto M.</p>
                <p className="text-xs text-slate-500" data-id="element-87">Buenos Aires</p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}
export function Problem() {
  return <section className="py-12 px-4" data-id="element-88">
      <div className="max-w-3xl mx-auto" data-id="element-89">
        <h2 className="text-2xl md:text-4xl font-bold text-center text-white mb-5" data-id="element-90">
          ¿Cuántas noches más vas a terminar así?
        </h2>

        <p className="text-slate-300 text-center text-[16px] mt-[11px] mb-[11px]" data-id="element-91">
          Sos una persona que quiere comer bien. Querés organizarte. Querés
          dejar de pedir delivery. Pero nadie te dijo que ibas a terminar cada
          martes a las 20:30 mirando el freezer vacío sin saber qué sacar,
          armando la cena con lo que queda y llegando al miércoles con la misma
          sensación de que algo salió mal.
        </p>

        <p className="text-lg font-bold text-center text-brand-400 mb-6" data-id="element-92">
          No es falta de ganas. Es falta de un sistema.
        </p>

        <Card className="bg-slate-900/80 border-red-900/30 mb-6" data-id="element-93">
          <ul className="space-y-3" data-id="element-94">
            {['Martes a las 20:30 mirando el freezer sin saber qué sacar', 'Comprás ingredientes que se vencen porque no planificaste la semana', 'Siempre el mismo delivery porque no tenés nada descongelado ni listo', 'Cocinás los domingos pero sin criterio y sin resultados que duren más de dos días', 'Los chicos con hambre, vos sin energía y la app de delivery abierta otra vez', 'Fin de semana agotado, lunes volvés a empezar el mismo ciclo'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-95">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-96" />
                <span className="text-slate-300 text-lg" data-id="element-97">{item}</span>
              </li>)}
          </ul>
        </Card>

        <h3 className="text-2xl md:text-3xl font-bold text-center text-white" data-id="element-98">
          ¿Y si esta fuera la última semana que te pasa esto?
        </h3>
      </div>
    </section>;
}